import { Components, Theme } from '@mui/material/styles';

export const MuiBreadcrumbs: Components<Theme>['MuiBreadcrumbs'] = {
  styleOverrides: {
    root: {
      maxWidth: '100%',
      overflowY: 'hidden',
      overflowX: 'auto',
      whiteSpace: 'nowrap',

      '& .MuiButtonBase-root': {
        backgroundColor: 'transparent',
      },
      '& .MuiSvgIcon-root': {
        fontSize: '12px',
      },
    },
    li: {
      '&:last-child': {
        color: 'var(--palette-action-active)',
      },
    },

    separator: {
      fontSize: 8,
      backgroundColor: 'transparent !important',
      color: 'var(--palette-divider) !important',
    },
  },
};
